<template>
  <div class="mx-2">
    <sButton
      v-if="show_all_btn"
      icon="repeat"
      type="text"
      @click="all = !all">
      {{ all ? $t('Application.HideWholeStory') : $t('Application.ShowWholeStory') }}
    </sButton>
    <div class="wrapper history">
      <EmptyTab
        v-if="!all_events.length"
        :text="$t('Common.NoData')"/>
      <template
        v-else
        v-for="(item, n) in all_events">
        <div
          v-if="all ? true : n > (all_events.length - 4)"
          :key="'questionId-'+n+(item.id || item.text || item.questionId)"
          class="mb-2"
          :data-qa="`history-item-${n}`"
          style="background: var(--white-color)">
          <HistoryItem
            :answer="item.answer"
            :avatar="item.organizationTitle"
            :commented="getResource(item)"
            :content="item.comment || item.content || item.question"
            :item="item"
            :item_time="item.time || item.timeStamp || item.questionTime || item.endAgree"
            :title="getTitle(item)"
            @toComment="$emit('toComment', item)"/>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import EmptyTab from 'components/common/elements/EmptyTab.vue'
import HistoryItem from 'components/common/elements/HistoryItem.vue'

import { i18n } from 'plugins/i18n.js'
import NotificationApi from '@/api/notificationApi'
import { modalMixin } from 'mixins'
const notif_api = new NotificationApi()

/**
 * Вопросы от участников
 */
export default {
  name: 'history',
  mixins: [ modalMixin],
  data() {
    return {
      all: false,
      was_selected: [],
      all_events: []
    }
  },
  props: {
    questions: Boolean,
    application: Object,
    comments: Array,
    history: Array,
    selected: Array,
    in_chat: Boolean,
    user: Object
  },
  filters: {
    formatDate(value) {
      if (value) {
        return `${i18n.d(new Date(value), 'shortDate')}, ${i18n.d(new Date(value), 'time')}`
      }
    },
  },
  created() {
    this.$root.$on('updateHisory', this.updateHisory)
    this.$root.$on('updateAllHisory', this.updateAllHisory)
    this.allHistory()
  },
  beforeDestroy() {
    this.$root.$off('updateHisory', this.updateHisory)
    this.$root.$off('updateAllHisory', this.updateAllHisory)
  },
  computed: {
    show_all_btn() {
      return this.all_events && this.all_events.length > 3
    },
    messages: {
      get() {
        let messages = []
        this.comments.forEach(comm => {
          if (this.selected?.length && (comm.chatType?.trim() != 'ROW'
            || !this.selected.some(sel => sel.id == comm.chatKey?.trim()?.split('/')[1])) ) {
            return
          }
          messages.push(...(comm.messages ?? []).slice(0))
        })
        return messages
      },
      set() {}
    },
    events: {
      get() {
        if (!this.history) { return [] }
        let result = []
        if ( this.selected && this.selected.length) {
          result = this.history.filter(comm => this.selected.some(sel => comm.rowId && sel.id == comm.rowId) )
        } else {
          result = this.history?.slice(0)
        }
        return result
      },
      set() {}
    },
  },
  methods: {
    async allHistory() {
      if (this.application ) {
        let result = [...this.messages]
        if ((this.selected && this.selected.length && !this.selected[0].only_chat) || !this.selected.length ) {
          result.push(...this.events)
        } else {
          // eslint-disable-next-line vue/no-mutating-props
          this.selected[0].only_chat = false
        }
        this.all_events = result.sort((a, b) => Date.parse(a.time || a.timeStamp) - Date.parse(b.time || b.timeStamp))
      } else {

        this.all_events = this.comments || []
      }
    },
    async updateHisory(event, is_event) {
      event = event || {}
      event.time = event.timeStamp
      if (is_event) {
        event.time = event.timeStamp
        this.events.push(event)
      } else if (!this.messages.find(el => el.id == event.id)) {
        this.messages.push(event)
      } else {
        await this.getUser(event)
        this.$forceUpdate()
      }
      this.allHistory()
    },
    updateAllHisory() {
      this.events = []
      this.messages = []
      this.all_events = []
      this.allHistory()
    },
    async getUser(item) {
      if (item.userId == this.user?.purchasingSettings?.userId?.trim() ) {
        item.user = {userId: item.userId}
      }
      await this.$store.dispatch('getUsers', [item.userId]).then(res => {
        item.user = res[0]
      })

      return item
    },
    getResource(item) {
      if (this.selected && this.selected.length) {
        let row = this.selected.find( el => item.id == el.id)
        if (row) {
          return row.resource?.fullName || row.resourceName
        }
      }
    },
    getDescription(item) {
      let description = this.$t('Common.Changed')
      // itemName = ''
      if (item.description) {
        description = item.description
      }
      // if (item.rowId) {
      //   itemName =  this.application.rows.find(i => i.id == item.rowId)
      //   return this.$t('Application.HostoryResorceNameEvent', { description, itemName: itemName?.resourceName })
      // }
      return description
    },
    getTitle(item) {
      let text
      if (item.__typename == 'ApplicationEventGraph') {
        text = this.getDescription(item)
      } else if (item.__typename == 'TenderDiscussionGraph') {
        text = this.$t('Tenders.Asked', {item: item.organizationTitle,
          theme: item.questionTitle ?  this.$t('Common.OnTheme', {theme: item.questionTitle }) : ''})
      } else if ( item.__typename == 'AgreeGraph' ) {
        text = (item.status == 'SUCCESS' ? this.$t('Tenders.Approved') :
          item.status == 'DECLINE' ?  this.$t('Tenders.Rejected') : 'wait' )
          + ' ' + this.smallFirstLetter(this.$t('Tenders.Tender'))
      } else {
        text = this.$t('Common.commented')
      }
      return text + ' ' + (item.itemName ? this.$t('Application.HostoryResorceName', item) : '')
    }
  },
  watch: {
    selected(val) {
      if ( this.application && val.length < this.was_selected.length) {
        let item = this.was_selected.find(el => !val.find(item => item.id == el.id)),
          user_index = item.chat?.chatUsers.findIndex(el => el.user.id == this.user?.purchasingSettings?.userId?.trim() )
        if (user_index > -1) {
          notif_api.signLastVisit(item?.chat?.id)
            .then(res => {
              item.chat.chatUsers[user_index] =  res.data.signLastVisit
              this.$store.commit('editApplicationRowData', item)
            })
            .catch(res => this.$log_error(res))
        }
      }
      this.allHistory()
      this.was_selected = val
    },
  },
  components: {
    EmptyTab,
    HistoryItem
  }
}
</script>
<style lang="scss" scoped>
.history-container {
  overflow: auto;
  .col {
    height: 100%;
  }
}
.wrapper {
  overflow: auto;
  height: calc(100% - 36px);
}
.history, .history .v-sheet {
  font-size: 12px;
  line-height: 16px;
}
.v-sheet {
  border-radius: 0 20px 20px 20px;
}
.history-item {
  font-size: 14px;
  text-align: start;
  color: var(--black-color);
  white-space: normal;
  .date-text {
    text-align: start;
    font-size: 12px;
    color: var(--black-color);
    opacity: 0.5;
  }
}
.name {
  font-weight: 500;
}
.avatar {
  max-width: 100%;
  max-height: 100%;
}
.v-list-item__avatar {
  margin-right: 4px !important;
}
.divider {
  border: 1px solid black !important;
  margin: 2px 0;
}
</style>
